export const CATEGORIES = ['all', 'paper', 'exploration', 'book'];

export const categoryLabel = {
  paper: '// paper',
  exploration: '// exploration',
  book: '// book',
};

export const statusStyle = {
  published: 'text-secondary border-secondary/30 bg-secondary/5',
  notes: 'text-stone-500 border-stone-300 bg-stone-100',
  project: 'text-blue-700 border-blue-600/30 bg-blue-50',
  wip: 'text-amber-700 border-amber-600/30 bg-amber-50',
  reading: 'text-purple-700 border-purple-600/30 bg-purple-50',
};

export const statusLabel = {
  published: 'published',
  notes: 'notes',
  project: 'project',
  wip: 'wip',
  reading: 'reading',
};
